var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArmeniaModal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V20H0V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20H80V40H0V20Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40H80V60H0V40Z",
    fill: "#FFA500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArmeniaModal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArmeniaModal.c75f4423.svg";
export { ForwardRef as ReactComponent };